import BaseController from './basePlayerController';

export default class ControllerTurboPlay extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_TURBO_SPIN: 'turbo_spin_button',
    };
    this._eEventTypes = {
      TURBO_SPIN_CLICK: this.getEventName(this._eButtonsTypes.EBT_TURBO_SPIN),
    };
    this._eElementsTypes = {
      EET_TURBO_SPIN_BUTTON: this._eButtonsTypes.EBT_TURBO_SPIN,
    };

    this.init(container);
  }

  toggleActive(value) {
    if (value) {
      this.interactiveElements[this._eElementsTypes.EET_TURBO_SPIN_BUTTON].classList.add('toggled_on');
    } else {
      this.interactiveElements[this._eElementsTypes.EET_TURBO_SPIN_BUTTON].classList.remove('toggled_on');
    }
  }

  _getMarkup() {
    return `<button id=${this.interactiveElementsIds[this._eElementsTypes.EET_TURBO_SPIN_BUTTON]}  data-color="primary">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M60.008 20.6557V37.7861H74.6258C75.4939 37.7663 76.3008 38.2318 76.7182 38.9933C77.1356 39.7548 77.094 40.6854 76.6103 41.4066L58.0272 68.6356C57.4413 69.4924 56.3698 69.8734 55.3746 69.5791C54.3793 69.2847 53.6875 68.382 53.662 67.3444V50.203H39.0516C38.1834 50.2228 37.3765 49.7573 36.9591 48.9958C36.5418 48.2343 36.5834 47.3036 37.0671 46.5825L55.6429 19.3645C56.2287 18.5077 57.3002 18.1266 58.2955 18.421C59.2907 18.7154 59.9825 19.6181 60.008 20.6557V20.6557Z" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M32.9954 66.0091H13.7374" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.3664 45.8341H7.31806" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M32.9954 25.659H13.7374" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>`
  }
}
